const normalizePartijValue = (value) => String(value || "").trim();

export const heeftZelfdePartijInhoud = (left, right) =>
  normalizePartijValue(left?.perceel) === normalizePartijValue(right?.perceel) &&
  normalizePartijValue(left?.gewicht) === normalizePartijValue(right?.gewicht) &&
  normalizePartijValue(left?.soort) === normalizePartijValue(right?.soort);
